<template>
	<view class="msg-container">

		<!-- 文本输入框 -->
		<view class="input-section">
			<textarea v-model="messageInput" :maxlength="200" :placeholder="'Select or input the message content'"
				@input="handleInput"></textarea>
			<text class="count">{{ messageInput.length }}/{{ 200 }}</text>
		</view>

		<!-- 快捷留言 -->
		<view class="quick-message">
			<text style="font-weight: bolder;color:#AC4E44;">Quick Messages</text>
			<view v-for="(quickMsg, index) in quickMessages" :key="index" class="quick-item"
				:class="{ selected: selectedQuickIndex === index }" @click="selectQuickMessage(index)">
				{{ quickMsg }}
			</view>
		</view>

		<!-- 保存按钮 -->
		<view class="save-button" @click="saveMessage" >
			<text>Save</text>
		</view>
	</view>
</template>

<script setup>
	import { defineEmits, ref } from 'vue';
	const emit = defineEmits(['saveMessage']);

    const messageInput = ref('');
    const quickMessages = ref(['Please call the owner. They will thank you!',
					'I\'m lost. Please help me find my family.',
					'He/She is my family. Return quickly for reward.',
					'Please contact my owner. Reward guaranteed.',
					'My owner is beautiful. Return me and get rich!',
					'Big eater. 10 bags of dog food. Energetic. Want home.',
					'Lost. Kind soul, help me get home.',
					'For me, he/she is family. Please contact me.',
					'Lost. Contact owner. Both me and owner will thank you.']);
    const saveMessage = () => { 
		emit('saveMessage', messageInput.value);
	};
    const selectedQuickIndex = ref(null);
    const selectQuickMessage = (index) => {
        selectedQuickIndex.value = index;
        messageInput.value = quickMessages.value[index];
    };
    const handleInput = () => {
        selectedQuickIndex.value = null; // Deselect quick message when typing
    };
</script>

<style scoped>
	.msg-container {
		display: flex;
		flex-direction: column;
		background-color: #E6DFCF;
		flex:1;
		align-items: center;
	}

	.input-section {
		margin-bottom: 10px;
		width:100%;
		background-color: #fff;
		border-radius: 20px;
		font-size: 12px;
		padding:8px 8px;
		padding-bottom: 0px;
	}

	textarea {
		width: 100%;
		height: 90px;
		border: 1px solid #ccc;
		border-radius: 5px;
		padding: 10px;
		border-style: hidden;
		font-size:16px;
	}

	.count {
		display: block;
		text-align: right;
		margin-top: 5px;
		font-size: 12px;
		color: #999;
		padding-right: 30px;
		padding-bottom: 5px;
	}

	.quick-message {
		display:flex;
		flex-direction: column;
		margin-bottom: 20px;
		text-align: center;
		gap:6px;
	}

	.quick-message text {
		display: block;
		/* margin-bottom: 10px; */
	}

	.quick-item {
		margin:0 auto;
		background-color: #f0f0f0;
		padding: 8px 6px;
		border-radius: 16px;
		/* margin-bottom: 10px; */
		cursor: pointer;
		font-size: 14px;
		color: #C5BCAC;
		align-items: center;
	}

	.selected {
		background-color: #920700;
		color:#fff;
		font-size: 18px;
	}

	.save-button {
		/* background-color: #f54545; */
		padding: 10px;
		width:200px;
		border-radius: 40px;
		text-align: center;
		background: linear-gradient(to bottom, #F03B34 0%, #8E0807 100%);
	}

	.save-button text {
		color: #fff;
		font-size: 16px;
	}

	@media (max-width: 895px){
		textarea{
			font-size: 12px;
		}

		.input-section{
			width:320px;
		}

		.quick-item {
			font-size:10px;
		}

		.save-button{
			width:200px;
		}

		.save-button text {
			color: #fff;
			font-size: 12px;
		}
	}
</style>